export default "__VITE_ASSET__81519cba__"